export const notifications = {
  successDataUpdate: 'Дані успішно змінюються.',
  errorOnDataUpdate: 'Коли дані змінюються, сталася помилка.',
  waitResponseIn24Hours:
    'Очікуйте відповіді на ваше запрошення протягом 72 годин.',
  workItemIsCanceled: 'Запрошення було знято',
  notificationDeleted: 'Повідомлення видалено',
  noNotifications: 'У вас немає сповіщень',
  workInviteRejected: 'Запрошення відхилено',
  workStartOnArtistArrivalConfirm:
    'Робота розпочнеться з моменту, коли клуб підтверджує вашу присутність на робочому місці.',
  giveResponseFormWorkItem:
    'Дайте відповідь на запрошення протягом 72 годин. Через 72 години запрошення буде видалено.',
  generalError: 'Щось пішло не так, спробуйте пізніше.',
  passwordReseted: 'Пароль відкидається',
  languageSwitched: 'Мова змінюється',
  invitationExpired: 'Термін дії запрошення закінчився',
  linkIsCopied: 'Посилання скопійовано',
  accountIsVisible: 'Обліковий запис буде показаний у пошуку',
  hiringEnabled: 'Набір Артистів відкритий',
  hiringDisabled: 'Набір Артистів закритий',
  rejectedForReason: 'Otclone через __var_0__',
  profileDeleted: 'Профіль видаляється',
  accountHiddenFromSearch:
    'Обліковий запис прихований і більше не відображається в пошуку Артистів',
  registerRequestSended: 'Було надіслано запит на реєстрацію',
  notFoundNotifications: 'У вас немає сповіщень',
  lastWorkDaySeted: 'Остання дата роботи встановлена'
};
